import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "dropdown", "item"]
  
  connect() {
    // Close dropdowns when clicking outside
    document.addEventListener('click', this.closeAllDropdowns.bind(this))
    // Update numbers on initial load
    this.updateTaskNumbers()
  }
  
  disconnect() {
    document.removeEventListener('click', this.closeAllDropdowns.bind(this))
  }
  
  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML('beforeend', content)
    this.updateTaskNumbers()
  }
  
  remove(event) {
    event.preventDefault()
    const item = event.target.closest('.reviewer-task-item')
    
    // If there's a hidden _destroy field, mark it for destruction
    const destroyInput = item.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = '1'
      item.style.display = 'none'
    } else {
      item.remove()
    }
    
    this.closeDropdown(event)
    this.updateTaskNumbers()
  }
  
  updateTaskNumbers() {
    const visibleItems = this.itemTargets.filter(item => item.style.display !== 'none')
    visibleItems.forEach((item, index) => {
      const label = item.querySelector('.task-number')
      if (label) {
        label.textContent = this.ordinalize(index + 1) + ' Reviewer Task'
      }
    })
  }
  
  ordinalize(num) {
    const suffixes = ['th', 'st', 'nd', 'rd']
    const v = num % 100
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0])
  }
  
  toggleDropdown(event) {
    event.preventDefault()
    event.stopPropagation()
    const dropdown = event.currentTarget.nextElementSibling
    
    // Close all other dropdowns
    this.dropdownTargets.forEach(d => {
      if (d !== dropdown) {
        d.classList.remove('show')
      }
    })
    
    dropdown.classList.toggle('show')
  }
  
  closeDropdown(event) {
    const dropdown = event.target.closest('.reviewer-task-dropdown')
    if (dropdown) {
      dropdown.classList.remove('show')
    }
  }
  
  closeAllDropdowns(event) {
    // Close dropdowns when clicking outside
    if (!event.target.closest('.reviewer-task-actions')) {
      this.dropdownTargets.forEach(dropdown => {
        dropdown.classList.remove('show')
      })
    }
  }
}
